import { Request } from "express";
import * as fs from "fs";
import * as Rollbar from "rollbar";
import * as tls from "tls";
import { SecureContext } from "tls";

export class BOBEnvironment {

	public static secureContexts = {};
	public static rollbar: Rollbar;

	/**
	 * Returns the fallback domain from the Bob configuration file located in
	 * the root of the project (bobconfig.json).
	 *
	 * @returns string
	 */

	public static getSecureContext(domain): SecureContext {

		domain = domain.replace("www.", "");

		try {

			if (typeof this.secureContexts[domain] === "undefined") {

				this.secureContexts[domain] = tls.createSecureContext({
					key: fs.readFileSync("SSL/" + domain + ".key").toString(),
					cert: fs.readFileSync("SSL/" + domain + ".crt").toString()
				}).context;
			}

			return this.secureContexts[domain];

		} catch (error) {

			if (domain === this.getFallBackDomain()) {

				throw error;
			}

			return this.getSecureContext(this.getFallBackDomain());
		}
	}

	public static getCorrectHostnameByRequest(request: Request): string {

		let hostname = request.hostname;

		// When running Bob standalone in development mode switch to the fallback domain.
		if (hostname.includes("localhost") || process.env.BOB_FORCE_FALLBACK_DOMAIN === 'true') {

			hostname = this.getFallBackDomain();
		} else if (hostname.startsWith("www.")) {

			return request.hostname.replace("www.", "www.origin.");
		} else {

			hostname = "origin." + hostname;
		}

		return hostname;
	}

	public static getValidDomains(): string[] {

		if (!process.env.BOB_VALID_DOMAINS) {

			return [];
		}

		return process.env.BOB_VALID_DOMAINS!.split(";");
	}

	public static getValidTopLevelDomains(): string[] {

		if (!process.env.BOB_VALID_TOP_LEVEL_DOMAINS) {

			return [];
		}

		return process.env.BOB_VALID_TOP_LEVEL_DOMAINS!.split(";");
	}

	public static getPort(): any {

		return process.env.PORT !== undefined ? process.env.PORT : process.env.BOB_PORT;
	}

	public static useHttps(): boolean {

		if (process.argv[2] === "--https") {

			process.env.BOB_IGNORE_SSL = "true";
			return true;
		}

		return false;
	}

	public static ignoreSSLVerification() {
		return process.env.BOB_IGNORE_SSL === "true";
	}

	public static getFallBackDomain(): string {
		return process.env.BOB_FALLBACK_DOMAIN!;
	}

	public static getEnvironment(): string {

		return process.env.BOB_ENVIRONMENT || "tst";
	}

	public static useCache(): boolean {
		return process.env.BOB_DISABLE_CACHE !== "true";
	}
}
